export const expensesReportsConstants = {
  EXPENSES_SUMMARY_REQUEST: 'REPORTS_GET_EXPENSES_SUMMARY_REQUEST',
  EXPENSES_SUMMARY_SUCCESS: 'REPORTS_GET_EXPENSES_SUMMARY_SUCCESS',
  EXPENSES_SUMMARY_FAILURE: 'REPORTS_GET_EXPENSES_SUMMARY_FAILURE',
}
